import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { endpoints } from "../../../ApiEndPoints/apiEndPoints";
import { storeDataTablePayload } from "../../../Redux/Actions/dataTableActions";
import store from "../../../Store/store";
import { DataTableType } from "../../../Types/editableFamilyGroupType";
import { IColumn } from "../../../Types/gridDataProps";
import { InformationPopup } from "../../SharedComponents/InformationPopup";
import { UI_CONSTANTS } from "../../../Constants/constants";
import { Table } from "@sainsburys-tech/luna-table";
import { DefaultTableCellRender } from "../../SharedComponents/EditableTable";
import { setCheckBoxData } from "../../../helpers/rowMatchHelper";
import { Tick } from "@sainsburys-tech/luna-icons";
import { IsNullEmptyUndefined } from "../Add-DuType/duTypeValidations";

const Management: FC<DataTableType> = (props: DataTableType) => {
  const user = useSelector((state: any) => state.auth.user);
  const columnDefinition: IColumn[] = [
    {
      name: "Container Type",
      accessor: "ContainerType",
    },
    {
      name: "Container Name",
      accessor: "ContainerName",
    },
    {
      name: "Description",
      accessor: "Description",
    },
    {
      name: `${UI_CONSTANTS.LEGACYCONTAINER}`,
      accessor: (rowData: any) => {
        return {
          value: rowData?.LegacyContainerDetails,
          row: rowData,
        };
      },
      renderFunc: ({ value, row }: { value: any; row: any }) => {
        return value ? (
          <div>
            <InformationPopup
              linkText={value?.length > 0 ? UI_CONSTANTS.LEGACYCONTAINER : null}
              modalHeading={`${UI_CONSTANTS.LEGACYCONTAINER} - ${row.ContainerType}`}
              dataPage="ContainerType"
              initialValue={row.LegacyContainerDetails[0].ContainerType}
            >
              <Table
                data={value}
                columns={[
                  {
                    name: "Customer Type",
                    accessor: (rowData: any) => ({
                      value: rowData.CustomerType,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Container Type",
                    accessor: (rowData: any) => ({
                      value: rowData.ContainerType,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Container Name",
                    accessor: (rowData: any) => ({
                      value: rowData.ContainerName,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Container Description",
                    accessor: (rowData: any) => ({
                      value: rowData.Description,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Preferred",
                    accessor: (rowData: any) => ({
                      value: rowData?.IsDefault,
                    }),
                    render: ({ value, row }: { value: any; row: any }) => (
                      <>{setCheckBoxData(value) ? <Tick /> : "--"}</>
                    ),
                    className: "tick_icon ",
                  },
                ]}
              />
            </InformationPopup>
          </div>
        ) : (
          "--"
        );
      },
    },
    {
      name: `${UI_CONSTANTS.LINKEDCONTAINER}`,
      accessor: (rowData: any) => {
        return {
          value: rowData?.LinkedContainers,
          row: rowData,
        };
      },
      renderFunc: ({ value, row }: { value: any; row: any }) => {
        return value?.length > 0 ? (
          <div>
            <InformationPopup
              //linkText={"Linked Containers"}
              linkText={value?.length > 0 ? UI_CONSTANTS.LINKEDCONTAINER : null}
              dataPage="ContainerType"
              initialValue={row.LinkedContainers[0].LinkedContainerType}
              //modalHeading={row.ContainerType}
              modalHeading={`${UI_CONSTANTS.LINKEDCONTAINER} - ${row.ContainerType}`}
            >
              <Table
                data={value}
                columns={[
                  {
                    name: "Linked Container Type",
                    accessor: (rowData: any) => ({
                      value: rowData.LinkedContainerType,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Linked Container Quantity",
                    accessor: (rowData: any) => ({
                      value: rowData.Quantity,
                    }),
                    render: DefaultTableCellRender,
                  },
                ]}
              />
            </InformationPopup>
          </div>
        ) : (
          "--"
        );
      },
    },

    {
      name: "Weights & Dims",
      accessor: (rowData: any) => {
        return {
          value: rowData,
          row: rowData,
        };
      },
      renderFunc: ({ value, row }: { value: any; row: any }) => {
        return value ? (
          <div>
            <InformationPopup
              linkText={value?.length > 0 ? UI_CONSTANTS.LEGACYCONTAINER : null}
              modalHeading={`Weights & Dims - ${row?.ContainerType}`}
              dataPage="Weights & Dims"
              initialValue={row?.ContainerType}
            >
              <Table
                data={[value]}
                columns={[
                  {
                    name: "Weight (KG)",
                    accessor: (rowData: any) => ({
                      value: rowData?.Weight,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Volume ",
                    accessor: (rowData: any) => ({
                      value: rowData?.Volume,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Full Length (CM)",
                    accessor: (rowData: any) => ({
                      value: rowData?.FullLength,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Full Width (CM)",
                    accessor: (rowData: any) => ({
                      value: rowData?.FullWidth,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Full Height (CM)",
                    accessor: (rowData: any) => ({
                      value: rowData?.FullHeight,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Weight Cap (KG)",
                    accessor: (rowData: any) => ({
                      value: rowData?.WeightCap,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Min Pick Volume",
                    accessor: (rowData: any) => ({
                      value: rowData?.MinPickVolume,
                    }),
                    render: DefaultTableCellRender,
                  },
                  {
                    name: "Max Pick Volume",
                    accessor: (rowData: any) => ({
                      value: rowData?.MaxPickVolume,
                    }),
                    render: DefaultTableCellRender,
                  },
                ]}
              />
            </InformationPopup>
          </div>
        ) : (
          "--"
        );
      },
    },
    {
      name: "LP Indicator",
      accessor: "LpIndicator",
      type: "tick",
    },
    {
      name: "MLP Indicator",
      accessor: "MlpIndicator",
      type: "tick",
    },
    {
      name: "MU Indicator",
      accessor: "MuIndicator",
      type: "tick",
    },
    {
      name: "Is Linkable",
      accessor: "IsLinkableContainer",
      type: "tick",
    },
  ];

  if (user?.isLDMAdmin) {
    columnDefinition.push({
      name: "",
      accessor: "",
      type: "btn",
      btnType: "both",
    });
  }

  useEffect(() => {
    let payload = {
      service: endpoints.getDuTypePaginated(),
      columnDefinition: columnDefinition,
      toggleSearchPanel: (e: any) => props.toggleSearchPanel(e),
    };
    store.dispatch(storeDataTablePayload(payload));
  }, []);

  return <></>;
};

export default Management;
